import React from 'react';


class ButtonSquare extends React.Component {
    constructor(props) {
      super(props);
    }
  
    render() {
      return (
        <button
          className="buttonSquare"
          style={{"background-color": this.props.alive? "#ff5638": "#e0e0e0"}}
          onClick={this.props.onClick}
        >
        </button>
      );
    }
  }

export default ButtonSquare;